import { render, staticRenderFns } from "./TextEditor2.vue?vue&type=template&id=998bfd96&scoped=true&"
import script from "./textEditor2.ts?vue&type=script&lang=ts&"
export * from "./textEditor2.ts?vue&type=script&lang=ts&"
import style0 from "./TextEditor2.vue?vue&type=style&index=0&id=998bfd96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998bfd96",
  null
  
)

export default component.exports